module.exports = {
      id: "logo-usage",
      viewBox: "0 0 196 61",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#logo",
      toString: function () {
        return this.url;
      }
    }